import mirrorVideoRight from "../assets/images/icons/mirror-video-right.svg";
import MirrorActivityLayout from "../components/MirrorActivityLayout";
import { useTranslation } from "../components/Localization";

export default function MirrorVideoRightTaskPage() {
  const { t } = useTranslation();
  return (
    <MirrorActivityLayout
      taskKey="videoRight"
      step={2}
      progressIcon="bottom-left"
      backTo="/tukorterem/video-bal"
      nextTo="/tukorterem/konzol"
    >
      <img
        className="mirror-room-diagram"
        src={mirrorVideoRight}
        alt={t("accessibility.mirrorSecondHalf")}
      />
    </MirrorActivityLayout>
  );
}
